import useWindowSize from '@/hooks/useWindowSize'
import clsx from 'clsx'
import { useState } from 'react'

import ScheduleCard from './ScheduleCard'
import { stages } from './utils'

/* styling */
import styles from './_.module.css'

function ElevateSchedule(): JSX.Element {
  const { size } = useWindowSize()
  const [activeStage, setActiveStage] = useState(1)

  return (
    <section
      id="schedule"
      className={clsx(
        'bg-[#070425] text-white | pt-16 pb-20 lg:py-40',
        styles.scheduleContainer
      )}
    >
      <div className="max-width-container">
        <header className="grid lg:grid-cols-12 gap-8 items-center | mb-12 lg:mb-20">
          <h2 className="font-heading text-4xl lg:text-5xl font-semibold | lg:col-start-1 lg:col-end-5">
            Event <span className={styles.textGradient1}>Schedule</span>
          </h2>

          {/* <p className="lg:text-lg | lg:col-start-6 lg:col-end-13">
            <strong className="text-xl font-semibold">
              50+ sessions across 3 stages.{' '}
            </strong>
            Hear from people with first-hand experience and gain intelligence
            into future proofing your business and career.
            <br />
            <br />
            <span className="text-yellow-30">NOTE: </span>
            All times given below are in Indian standard time(IST) GMT+5:30{' '}
          </p> */}
        </header>

        <div className="flex md:hidden gap-8 | mb-9">
          {Object.values(stages).map(stage => {
            const _isActive = activeStage === stage.no
            return (
              <button
                key={stage.title}
                className={clsx(
                  'text-xl | flex flex-col',
                  _isActive && 'font-semibold'
                )}
                onClick={() => setActiveStage(stage.no)}
              >
                <span className="py-2">{stage.title}</span>
                {_isActive && (
                  <div
                    className="w-full h-0.5"
                    style={{ background: stage.gradient }}
                  />
                )}
              </button>
            )
          })}
        </div>

        <section className="grid lg:grid-cols-2 gap-8">
          {Object.values(stages).map(stage => {
            const _isActive = activeStage === stage.no
            if (!_isActive && size.width <= 640) return null

            return (
              <div
                key={stage.title}
                className={clsx('w-full h-fit | mx-auto', styles.scheduleList)}
                style={{
                  background:
                    'linear-gradient(86.47deg, rgba(255, 255, 255, 0.17) 0.88%, rgba(12, 5, 76, 0) 157.95%)',
                  marginTop: size.width >= 1024 ? `${3 * (3 - stage.no)}rem` : 0
                }}
              >
                <div className="px-5 py-8">
                  <h3 className="text-2xl font-medium | hidden md:block | mb-2">
                    {stage.title}
                  </h3>
                  <h4 className="font-heading text-3xl lg:text-4xl font-semibold">
                    <span
                      style={{
                        background: stage.gradient,
                        WebkitBackgroundClip: 'text',
                        WebkitTextFillColor: 'transparent'
                      }}
                    >
                      {stage.topic}
                    </span>
                  </h4>
                </div>
                <div className="space-y-8">
                  {stage.events.map(event => (
                    <ScheduleCard
                      key={event.title}
                      stage={stage.no}
                      data={event}
                    />
                  ))}
                </div>
              </div>
            )
          })}
        </section>
      </div>
    </section>
  )
}

export default ElevateSchedule
